<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('昵称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile" @pressEnter="handleQuery" :placeholder="$t('请输入')+$t('手机号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户等级')" prop="status">
                <a-select :placeholder="$t('请选择')+$t('用户等级')" v-model="queryParam.levelId" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('国家')" prop="status">
                <a-select :placeholder="$t('请选择')+$t('国家')" v-model="queryParam.country" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in countryList" :key="index" :value="d">{{ d }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['biz:user:add']">
          <a-icon type="plus" />
          {{ $t('新增') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDisable(undefined)" v-hasPermi="['biz:user:edit']">
          {{ $t('禁用') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />
          {{ $t('导出') }}
        </a-button>
        <!--        <a-button type="primary" :disabled="single" @click="handleReset(undefined, ids)" v-hasPermi="['biz:user:reset']">-->
        <!--          <a-icon type="edit" />-->
        <!--          重置密码-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['biz:user:export']">-->
        <!--          <a-icon type="download" />-->
        <!--          {{ $t('选中导出') }}-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :statusOptions="dict.type['sys_enable_disable']"
        :is-notice-options="dict.type['sys_notice_status']"
        :sex-options="dict.type['sys_user_sex']"
        @ok="getList"
      />

      <detail-view
        ref="detailViewRef"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex" />
        </span>
        <!--        <span slot="isNotice" slot-scope="text, record">
                  <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
                </span>-->
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <template slot="avatar" slot-scope="text, record">
          <div style="width: 60px; height: 60px; overflow:hidden; display: flex; justify-content: center; align-items: center;">
            <img v-if="record.avatar" :src="record.avatar" style="width:60px;height:60px;" @click="handleRecordPreview(record.avatar)" alt="none" />
          </div>
        </template>
        <div slot="registerChannel" slot-scope="text, record">
          <span v-if="record.registerChannel === 'APP'">用户APP</span>
        </div>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="lastLoginTime" slot-scope="text, record">
          {{ parseTime(record.lastLoginTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDisable(record)" v-hasPermi="['biz:user:edit']">
              {{ $t('禁用') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['biz:user:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, [])" v-hasPermi="['biz:user:edit']">
              {{ $t('修改') }}
          </a>
          <a-divider type="vertical" />
          <a @click="$refs.detailViewRef.handleShowDetail(record.id)">
              {{ $t('详情') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, resetUser, countryListUser, disableUser } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { tableMixin } from '@/store/table-mixin'
import { listLevel } from '@/api/user/level'
import DetailView from '@/views/user/user/modules/DetailView.vue'

export default {
  name: 'Appuser',
  components: {
    DetailView,
    CreateForm,
    CustomDictTag
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable', 'sys_notice_status', 'sys_user_sex'],
  data() {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      levelList: [],

      selectedRowKeys: [],
      selectedRows: [],
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        allianceId: undefined,
        mobile: null,
        nickName: null,
        sex: undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户ID'),
          dataIndex: 'id',
          align: 'center',
          width: '180px',
          fixed: 'left'
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
          width: '180px',
          fixed: 'left'
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          width: '120px',
          align: 'center'
        },
        {
          width: '150px',
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('生日'),
          dataIndex: 'birthday',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('国家'),
          dataIndex: 'country',
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('个人简介'),
          dataIndex: 'introduction',
          width: '180px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户等级'),
          dataIndex: 'levelName',
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('下单次数'),
          dataIndex: 'orderTotalCount',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('下单总金额'),
          width: '180px',
          dataIndex: 'orderTotalAmount',
          align: 'center'
        },
        {
          title: this.$t('积分值'),
          dataIndex: 'score',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('用户余额'),
          dataIndex: 'balance',
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('注册渠道'),
          dataIndex: 'registerChannel',
          scopedSlots: { customRender: 'registerChannel' },
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('用户状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('最后登录时间'),
          dataIndex: 'lastLoginTime',
          scopedSlots: { customRender: 'lastLoginTime' },
          width: '180px',
          align: 'center'
        },
        {
          title: this.$t('注册时间'),
          width: '180px',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '200px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      countryList: []
    }
  },
  filters: {},
  created() {
    this.getCountryList()
    this.getLevelList()
    this.getUserRouteList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getUserRouteList() {
      const params = this.$route.params || {}
      const query = this.$route.query || {}
      const allianceId = params.allianceId || query.allianceId
      const userId = params.userId || query.userId
      if (allianceId) {
        this.queryParam.allianceId = allianceId
      }
      if (userId) {
        this.queryParam.id = userId
      }
      this.getList()
    },
    getCountryList() {
      countryListUser().then(response => {
        this.countryList = response.data
      })
    },
    getLevelList() {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        allianceId: undefined,
        mobile: undefined,
        nickName: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `${that.$t('用户信息')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleReset() {
      let form = { id: this.ids[0] }
      resetUser(form).then(response => {
        this.$message.success(
          this.$t('重置成功'),
          3
        )
      }).finally(() => {
        this.submitLoading = false
      })
      this.ids = []
    },
    handleSelectExport() {
      var that = this
      let queryParam = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk() {
          that.download('biz/user/export', queryParam, `${that.$t('用户信息')}_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        },
        onCancel() {
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        }
      })
    },
    handleDisable(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认禁用所选中数据?'),
        content: this.$t('当前选中编号为') + ids + this.$t('的数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return disableUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('禁用成功'),
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    }
  }
}
</script>
